import React from 'react';
import Icon from './Icon';

export default function PainPointCard({ pain }) {
  return (
    <article className="card pain-card">
      <div className="pain-icon">
        <Icon name={pain.icon} size={22} />
      </div>
      <h3 className="pain-title">{pain.title}</h3>
      <p className="pain-desc">{pain.desc}</p>
    </article>
  );
}
